
import { Component, Vue } from "vue-property-decorator";
import { Action, State } from "vuex-class";

@Component({
  components: {},
})
export default class LayoutHeader extends Vue {
  @Action fetchLogout!: Function;
  @State userInfo!: object;
  @State isLogin!: object;
  @State applyStatus!: number;
  async doLogout() {
    this.fetchLogout(() => {
      this.$message.success("已退出登录");
    });
  }

  goToLogin() {
    this.$router.push({ path: "/login" });
  }

  goToJoin() {
    this.$router.push({ path: "/join" });
  }

  clickToHome() {
    window.open("https://www.shopmang.com");
  }

  clickToSeller() {
    window.open("https://seller.mgtv.com");
  }
}
